var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHamburgerinline = function SvgHamburgerinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "hamburger")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hamburger_inline_svg__hamburger",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 30,
    x2: 56,
    y2: 30,
    id: "hamburger_inline_svg__Path-41-Copy",
    stroke: "#000000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 14,
    x2: 56,
    y2: 14,
    id: "hamburger_inline_svg__Path-41",
    stroke: "#000000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 46,
    x2: 4,
    y2: 46,
    id: "hamburger_inline_svg__Path-41",
    stroke: "#000000",
    strokeWidth: 3
  }))));
};
export default SvgHamburgerinline;